import type { FetchResult } from '@apollo/client';

import { useSession } from '@hooks/useSession';

import type {
  UpdateCurationStatusMutation,
  UpdateCurationStatusMutationVariables,
  UpdateRecordSourceMutation,
  UpdateRecordSourceMutationVariables,
} from 'generated/curation-meta.generated';
import {
  useUpdateCurationStatusMutation,
  useUpdateRecordSourceMutation,
} from 'generated/curation-meta.generated';

export function useUpdateCurationStatus(): [
  (
    params: UpdateCurationStatusMutationVariables
  ) => Promise<FetchResult<UpdateCurationStatusMutation>>,
  boolean,
] {
  const {
    state: { activeProfile },
  } = useSession();
  const patient_id = activeProfile?.patient_id;
  const [mutate, { loading: baseLoading }] = useUpdateCurationStatusMutation();
  const loading = baseLoading;

  async function updateCurationStatus(
    params: UpdateCurationStatusMutationVariables
  ) {
    const response = await mutate({
      variables: { ...params },
      update: (cache, { data }) => {
        if (!data?.updateCurationStatus) {
          return;
        }
        cache.evict({
          fieldName: 'getMostRecentRecords',
          args: {
            patient_id,
          },
        });
      },
    });
    return response;
  }
  return [updateCurationStatus, loading];
}

export function useUpdateRecordSource(): [
  (
    params: UpdateRecordSourceMutationVariables
  ) => Promise<FetchResult<UpdateRecordSourceMutation>>,
  boolean,
] {
  const [mutate, { loading: baseLoading }] = useUpdateRecordSourceMutation();
  const loading = baseLoading;

  async function updateRecordSource(
    params: UpdateRecordSourceMutationVariables
  ) {
    const response = await mutate({
      variables: { ...params },
    });
    return response;
  }
  return [updateRecordSource, loading];
}
